import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as typography from "@styles/typography.module.css";
import * as styles from "./pagesSection.module.css";
const PagesSection = () => {
    return (_jsxs("div", { className: styles.pagesSection, children: [_jsx("p", { className: typography.subHeader2, children: "P\u00E1ginas" }), _jsx("a", { className: typography.bodySmall, href: "#servicesSection", children: "Servi\u00E7os" }), _jsx("a", { className: typography.bodySmall, href: "#contactSection", children: "Contato" }), _jsx("a", { className: typography.bodySmall, href: "#clientsSection", children: "Clientes" })] }));
};
export default PagesSection;
